import { StackProps } from "@mui/material"
import Pagination from "src/shared/container/pagination"

const PaginationControls = ({
  table,
  hideRowsPerPage,
  rowsPerPageOptions = [10, 20, 30],
  justifyContent = "flex-end"
}: {
  table: any
  hideRowsPerPage?: boolean
  rowsPerPageOptions?: number[]
  justifyContent?: StackProps["justifyContent"]
}) => {
  return (
    <Pagination
      pageIndex={table.getState().pagination.pageIndex}
      pageSize={table.getState().pagination.pageSize}
      pageCount={table.getPageCount()}
      hidePageSizeOptions={hideRowsPerPage}
      pageSizeOptions={rowsPerPageOptions}
      onPageChange={(pageIndex) => table.setPageIndex(pageIndex)}
      onPageSizeChange={(pageSize) => table.setPageSize(pageSize)}
      justifyContent={justifyContent}
    />
  )
}

export default PaginationControls
